import { $host } from './index';

export const fetchCancellationReasons = async () => {
  const { data } = await $host.get('web/cancellation-reasons');
  return data;
};

export const createOrUpdateCancellationReason = async (reason) => {
  const { data } = await $host.post('web/cancellation-reasons', reason);
  return data;
};

export const deleteCancellationReason = async (id) => {
  const { data } = await $host.post('web/cancellation-reasons/remove', { id });
  return data;
};

export const reorderCancellationReasons = async (items) => {
  const { data } = await $host.post('web/cancellation-reasons/reorder', { items });
  return data;
};
